<template>
  <div class="breadcrumb-container">
    <el-breadcrumb class="bc-container" separator="/">
      <!-- route.path 可能是一个路由参数导航，比如 /test/index/:id -->
      <el-breadcrumb-item v-for="(route, index) in list" :key="route.path">
        <span v-if="index === list.length - 1">{{ route.meta?.title }}</span>
        <a v-else @click="handleLink(route)">{{ route.meta?.title }}</a>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { compile } from 'path-to-regexp';

export default {
  name: "Breadcrumb",
  data() {
    return {
      list: [],
    };
  },
  computed: {
    routeList() {
      return this.$route.matched;
    },
  },
  mounted() {},
  watch: {
    '$route.path': {
      immediate: true,
      handler(){
        this.getBreadCrumb();
      }
    }
  },
  methods: {
    // 从 route.matched 中获取面包屑导航列表
    getBreadCrumb(){
      // 去掉没有title，和指定不限制在面包屑中的
      let matched = this.$route.matched.filter((match) => match.meta.title && !match.meta.hideBreadcrumb);
      if (matched.length < 1) return;
      if (matched[0].path !== '/home') {
        //当前访问的不是首页的，在前面增加首页
        matched = [{ path: '/home', meta: { title: '首页' }}, ...matched];
      }
      
      this.list = matched;
    },
    // 面包屑点击回调
    handleLink(info){
      const route = this.$route;
      const { path, redirect } = info;
      
      // 如果是重定向路由 就⾛重定向路径
      if (redirect) this.$router.push(redirect).catch(() => {});
      // 如果⾯包屑导航是动态路由时，拼接成正常路由再进行跳转
      const resovePath = compile(path)(route.params);
      this.$router.push(resovePath).catch(() => {});
    }
  },
};
</script>
<style lang="scss" scoped>
.breadcrumb-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  ::v-deep {
    .el-breadcrumb__inner a,
    .el-breadcrumb__inner.is-link {
      color: var(--primary-color);
    }
    .el-breadcrumb__item:last-child .el-breadcrumb__inner {
      color: #fff;
    }
  }
}
</style>
